import * as React from 'react';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

import { isNil, parseValue } from 'app/utils';

import type { RegulationsField } from './RegulationsField.types';
import { useRegulationsFieldValue } from './useRegulationsFieldValue';

export type RegulationsSwitchFieldProps = {
  field: RegulationsField;
  className?: string;
};

const RegulationsSwitchFieldComponent = ({ field, className }: RegulationsSwitchFieldProps) => {
  const { name, value, defaultValue, disabled = false } = field;

  const initialValue = React.useMemo(() => {
    const source = isNil(value) ? defaultValue : value;
    return parseValue(source, 'boolean', false);
  }, [value, defaultValue]);

  const [currentValue, commit] = useRegulationsFieldValue<boolean>(name, initialValue);

  const onChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => commit(event.target.checked),
    [commit],
  );

  return (
    <FormControlLabel
      className={className}
      control={<Switch checked={!!currentValue} disabled={disabled} onChange={onChange} />}
      label={''}
    />
  );
};

export const RegulationsSwitchField = React.memo(RegulationsSwitchFieldComponent);
